var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tipBlock",staticClass:"d-follow-tip",class:{
    bottom: _vm.isPopupOutOfScreen && _vm.isPopupOutOfScreen.bottom,
    left: _vm.isPopupOutOfScreen && _vm.isPopupOutOfScreen.left,
    right: _vm.isPopupOutOfScreen && _vm.isPopupOutOfScreen.right,
  },style:(_vm.position),on:{"mouseleave":_vm.closeTip,"scroll":_vm.closeTip}},[_c('span',{staticClass:"tip"}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Follow "+_vm._s(_vm.authorInfo.author_name)+"?")]),_vm._v(" "),_c('DFollowButton',{attrs:{"user-id":_vm.authorInfo.author_id,"is-small-button":true,"is-black-button":true},on:{"add-follow":_vm.addFollow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }